<template>
  <div>

    <Card>
      <Select v-model="searchKey" style="width:200px;padding: 10px;" clearable>
          <Option v-for="item in storageServerColumns" :value="item.key" :key="item.key">{{ item.title }}</Option>
      </Select>
      <Input v-model="searchValue" placeholder="Enter something..." style="width: 200px;padding: 10px;" clearable @keyup.enter.native="storageServer"></Input>
      <Button type="primary" :loading="loading" icon="checkmark-round" style="margin-right: 10px;" @click="storageServer">
          <span v-if="!loading">搜索</span>
          <span v-else>Loading...</span>
      </Button>
      <Button type="info" @click="addStorageServer">新增</Button>

      <tables border v-model="storageServerData" :loading="loading" :columns="storageServerColumns"  @on-delete="handleDelete"/>

      <page :total="total" :current="pageIndex" :page-size="pageSize" @on-change="currentChange" show-elevator show-sizer @on-page-size-change="pageSizeChange"></page>

    </Card>

    <drag-drawer v-model="storageServerModal"
      :width.sync="drag_drawer_width"
      :min-width="300"
      placement="right"
      :draggable="true"
      :scrollable="true">
      <div slot="header">
        <Icon type="md-aperture" :size="18"></Icon>
        <b> {{ storageServerInfo.id === undefined || storageServerInfo.id === null ? '新增' : '编辑' }} </b>
      </div>
      <Form ref="storageServerForm" :model="storageServerInfo" inline :label-width="100" label-position="right" :rules="storageServerRule">

        <div>
          <FormItem label="属性" style="width: 100%" prop="attribute">
            <Select v-model="storageServerInfo.attribute" :disabled="!(storageServerInfo.id === undefined || storageServerInfo.id === null)" style="min-width:220px">
              <Option :value="item" :key="item" v-for="item in ['私有云', '公有云']">{{ item }}</Option>
            </Select>
          </FormItem>
          <Divider orientation="left">基础信息</Divider>
          <FormItem label="系统" style="width: 100%" prop="attribute">
            <Select v-model="storageServerInfo.system" style="min-width:220px">
              <Option :value="item" :key="item" v-for="item in ['Linux', 'Windows']">{{ item }}</Option>
          </Select>
          </FormItem>
          <FormItem :label="value" :prop="key" v-for="(value, key) in {name: '名称', hostIp: 'IP', port: '端口', username: '用户名', password: '密码', platform: '平台', area: '区域'}" :key="key">
            <Input v-model="storageServerInfo[key]" style="min-width: 220px" />
          </FormItem>
        </div>

        <FormItem label="备注" style="width: 100%">
          <Input type="textarea" v-model="storageServerInfo.remark" />
        </FormItem>

        <FormItem>
          <Row>
            <Col span="6" offset="8">
              <i-button type="primary" @click="submit()">提交</i-button>
            </Col>
            <Col span="6" offset="4">
              <i-button style="margin-left: 8px" @click="storageServerModal = false">取消</i-button>
            </Col>
          </Row>
        </FormItem>

      </Form>
    </drag-drawer>

    <!-- 日志-->
    <BaseLogModal
      :visible="logShow"
      :api.sync="logApi"
      :slot-content="false"
      :query="{
        dataId:logId,
        dataType:1
      }"
      @closeModal="e=>{logShow=e}"
    />

  </div>
</template>

<script>
import Tables from '_c/tables'
import { storageServer, InsertStorageServer, DeleteStorageServer, UpdateStorageServer, connectivity } from '@/api/backup-storage'
import DragDrawer from '_c/drag-drawer'
import BaseLogModal from './log'
import config from '@/config'
export default {
  name: 'StorageServer',
  props: {
  },
  components: {
    Tables,
    DragDrawer,
    BaseLogModal
  },
  data () {
    return {
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      searchKey: '',
      searchValue: '',
      loading: false,
      storageServerModal: false,
      drag_drawer_width: 710,
      // 日志
      logShow: false,
      logId: null,
      logApi: `${config.backupStorageApi}/sys-user-opera-log`,
      storageServerColumns: [
        { title: '名称', key: 'name', ellipsis: true, tooltip: true, align: 'center' },
        { title: 'ip', key: 'hostIp', ellipsis: true, tooltip: true, align: 'center' },
        { title: '端口', key: 'port', ellipsis: true, tooltip: true, align: 'center' },
        { title: '系统', key: 'system', ellipsis: true, tooltip: true, align: 'center' },
        { title: '属性', key: 'attribute', ellipsis: true, tooltip: true, align: 'center' },
        { title: '平台', key: 'platform', ellipsis: true, tooltip: true, align: 'center' },
        { title: '区域', key: 'area', ellipsis: true, tooltip: true, align: 'center' },
        { title: '用户', key: 'username', ellipsis: true, tooltip: true, align: 'center' },
        { title: '密码', key: 'password', ellipsis: true, tooltip: true, align: 'center' },
        { title: '创建时间', key: 'createdAt', ellipsis: true, tooltip: true, align: 'center' },
        { title: '更新时间', key: 'updatedAt', ellipsis: true, tooltip: true, align: 'center' },
        { title: '备注', key: 'remark', ellipsis: true, tooltip: true, align: 'center' },
        {
          title: '操作',
          minWidth: 180,
          key: 'opeation',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Badge',
                {
                  style: {
                    background: '#5cb85c !important;'
                  },
                  props: {
                    dot: false,
                    count: '.',
                    className: params.row.connectStatus
                  }
                },
                [
                  h('Button', {
                    props: {
                      type: 'warning',
                      size: 'small',
                      loading: params.row.loading,
                      icon: params.row.connectStatus === 'success' ? 'checkmark' : params.row.connectStatus === 'false' ? 'close' : ''
                    },
                    on: {
                      click: () => {
                        params.row.loading = true
                        connectivity({ id: params.row.id }).then(_ => {
                          params.row.loading = false
                          params.row.connectStatus = 'success'
                          this.$Message.success({ content: '成功', duration: 10 })
                        }).catch(err => {
                          const { message } = JSON.parse(err.request.responseText)
                          this.$Message.error({ content: message, duration: 10 })
                          params.row.loading = false
                          params.row.connectStatus = 'false'
                        })
                      }
                    }
                  }, '连通性')
                ]
              ),
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginLeft: '13px',
                  marginBottom: '5px',
                  marginTop: '5px'
                },
                on: {
                  click: () => {
                    this.storageServerInfo = params.row
                    this.storageServerModal = true
                  }
                }
              }, '编辑'),
              h(
                'Poptip',
                {
                  style: {
                    marginBottom: '5px',
                    marginTop: '5px'
                  },
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'top',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.handleDelete(params)
                    }
                  }
                },
                [
                  h(
                    'Button',
                    {
                      style: {
                        marginLeft: '10px',
                        marginBottom: '5px',
                        marginTop: '5px'
                      },
                      props: {
                        type: 'error',
                        size: 'small'
                      }
                    },
                    '删除'
                  )
                ]
              ),
              h('Button', {
                style: {
                  marginLeft: '10px',
                  marginBottom: '5px',
                  marginTop: '5px'
                },
                props: {
                  type: 'dashed',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.showLogEvent(params.row)
                  }
                }
              }, '日志')
            ])
          }
        }
      ],
      storageServerData: [],
      storageServerInfo: {
        name: null,
        hostIp: null,
        port: null,
        system: null,
        attribute: null,
        platform: null,
        area: null,
        username: null,
        password: null,
        remark: null
      },
      storageServerRule: {
        name: [{ required: true, message: '名称填写不能为空', trigger: 'blur' }],
        hostIp:
        [{
          required: true,
          pattern: /^(?:(?:1[0-9][0-9]\.)|(?:2[0-4][0-9]\.)|(?:25[0-5]\.)|(?:[1-9][0-9]\.)|(?:[0-9]\.)){3}(?:(?:1[0-9][0-9])|(?:2[0-4][0-9])|(?:25[0-5])|(?:[1-9][0-9])|(?:[0-9]))$/,
          message: '请输入正确的IP地址',
          trigger: 'blur'
        }],
        port: [{ required: true, message: '端口填写不能为空', trigger: 'blur' }],
        system: [{ required: true, message: '系统填写不能为空', trigger: 'blur' }],
        attribute: [{ required: true, message: '属性填写不能为空', trigger: 'blur' }],
        username: [{ required: true, message: '用户填写不能为空', trigger: 'blur' }],
        password: [{ required: true, message: '密码填写不能为空', trigger: 'blur' }]
      }
    }
  },
  watch: {
  },
  methods: {

    handleDelete (params) {
      const { id } = params.row
      DeleteStorageServer({ id: id }).then(rsp => {
        const { data } = rsp
        this.$Message.success({ content: data.message, duration: 10 })
        this.storageServer()
      }).catch(err => {
        const { message } = JSON.parse(err.request.responseText)
        this.$Message.error({ content: message, duration: 10 })
        this.storageServer()
      })
    },

    storageServer (current) {
      const params = {
        pageSize: this.pageSize,
        pageIndex: current,
        currentPage: current
      }
      if (this.searchKey) {
        params[this.searchKey] = this.searchValue
      }
      storageServer(params).then(rsp => {
        const { data } = rsp
        if (data) {
          data.items.forEach(element => {
            element.loading = false
            element.connectStatus = 'waiting'
          })
          this.storageServerData = data.items
          this.total = data.total
        }
      })
    },

    submit () {
      this.$refs['storageServerForm'].validate((valid) => {
        if (valid) {
          if (this.storageServerInfo.id === undefined || this.storageServerInfo.id === null) {
            InsertStorageServer(this.storageServerInfo).then(rsp => {
              const { data } = rsp
              this.$Message.success({ content: data.message, duration: 10 })
              this.storageServerModal = false
              this.storageServer()
            }).catch(err => {
              const { message } = JSON.parse(err.request.responseText)
              this.$Message.error({ content: message, duration: 10 })
              this.storageServerModal = false
              this.storageServer()
            })
          } else {
            UpdateStorageServer(this.storageServerInfo).then(rsp => {
              const { data } = rsp
              this.$Message.success({ content: data.message, duration: 10 })
              this.storageServerModal = false
              this.storageServer()
            }).catch(err => {
              const { message } = JSON.parse(err.request.responseText)
              this.$Message.error({ content: message, duration: 10 })
              this.storageServerModal = false
              this.storageServer()
            })
          }
        } else {
          this.$Message.error('请检查是否存在填写异常项')
        }
      })
    },

    addStorageServer () {
      this.storageServerModal = true
      this.storageServerInfo = {
        id: null,
        name: null,
        hostIp: null,
        port: null,
        system: null,
        attribute: null,
        platform: null,
        area: null,
        username: null,
        password: null,
        remark: null
      }
    },

    showLogEvent (row) {
      this.logShow = false
      this.logId = row.id
      this.logShow = true
    },

    currentChange (e) {
      this.pageIndex = e
      this.storageServer(e)
    },

    pageSizeChange (e) {
      this.pageSize = e
      this.storageServer()
    }

  },

  created: function () {
  },

  mounted: function () {
    this.storageServer()
  }

}
</script>

<style>
  .success{
    background: #5cb85c !important;
  }
  .waiting{
    background: orange !important;
  }

</style>
